//Responsive Loading Spinner, used in Individual Widget, when they are loading.
import React from 'react';
import { BeatLoader } from 'react-spinners';
import '../css/loadingSpinner.css';

const LoadingSpinner = function(props) {
    return <div className="loadingSpinnerContainer">
              <BeatLoader color={'#bb0000'} loading={props.loading} size={15} />
           </div>
  };

export default LoadingSpinner;